import { georgeMediaArray } from './georgeMedia'
import { georgeBio } from './georgeBios'

import { elaineReviewerReviewHinge, jerryReviewerReviewBumble, kramerReviewerReviewTinder } from './georgeReviewerReviews'
import { elaineReviewerProfile, jerryReviewerProfile, kramerReviewerProfile } from './georgeReviewers'

export const elaineProfileReviewHinge = {
  _id: 'elaineProfileReviewHingeId',
  userId: 'georgeUserId',
  userEmail: 'george@email.com',
  datingProfileId: 'georgeDatingProfileHingeId',
  reviewerProfileId: 'elaineReviewerProfileId',
  reviewerEmail: 'elaine@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: georgeMediaArray[16]._id,
      mediaItemURL: georgeMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[16].type,
      caption: georgeMediaArray[16].captions[0],
      subcaption: georgeMediaArray[16].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[11]._id,
      mediaItemURL: georgeMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[11].type,
      caption: georgeMediaArray[11].captions[1],
      subcaption: georgeMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: georgeMediaArray[12]._id,
      mediaItemURL: georgeMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[12].type,
      caption: georgeMediaArray[12].captions[2],
      subcaption: georgeMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: georgeMediaArray[10]._id,
      mediaItemURL: georgeMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[10].type,
      caption: georgeMediaArray[10].captions[2],
      subcaption: georgeMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[13]._id,
      mediaItemURL: georgeMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[13].type,
      caption: georgeMediaArray[13].captions[0],
      subcaption: georgeMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[17]._id,
      mediaItemURL: georgeMediaArray[17].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[17].type,
      caption: georgeMediaArray[17].captions[1],
      subcaption: georgeMediaArray[17].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow this is about as good as you're capable of looking. Good job`,
      verdict: 'Yes',
    },
    {
      feedback: `No... just no`,
      verdict: 'No',
    },
    {
      feedback: `Just when I thought it couldn't get any worse`,
      verdict: 'No',
    },
    {
      feedback: `A little bit funny as a change of pace photo`,
      verdict: 'Somewhat',
    },
    {
      feedback: `The worst one yet`,
      verdict: 'No',
    },
    {
      feedback: `OK, this one is actually good`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: georgeBio._id,
    vitalInfo: { ...georgeBio.vitalInfo },
    prompts: [
      { ...georgeBio.prompts[0] },
      { ...georgeBio.prompts[1] },
      { ...georgeBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `What happens when they find out you're not actually an architect?`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `If this is a joke nobody will get it`,
        verdict: 'No', 
      },
      {
        feedback: `This is grotesque`,
        verdict: 'No', 
      },
      {
        feedback: `Kind of funny, sure`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `George is a total slob`,
    good: `The first photo and the friend pic were good. All of the others weren't`,
    notGood: `The scowls, the sloppiness, and the disregard for general decency`,
    verdict: `George is nowhere close to presenting an attractive self, though, now that I think about it, this may be *his* most attractive self`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...elaineReviewerReviewHinge },
  reviewerProfile: { ...elaineReviewerProfile },
  bioItems: { ...georgeBio },
  mediaItems: [ ...georgeMediaArray ],
}

export const jerryProfileReviewBumble = {
  _id: 'jerryProfileReviewBumbleId',
  userId: 'georgeUserId',
  userEmail: 'george@email.com',
  datingProfileId: 'georgeDatingProfileBumbleId',
  reviewerProfileId: 'jerryReviewerProfileId',
  reviewerEmail: 'jerry@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: georgeMediaArray[16]._id,
      mediaItemURL: georgeMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[16].type,
      caption: georgeMediaArray[16].captions[0],
      subcaption: georgeMediaArray[16].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[11]._id,
      mediaItemURL: georgeMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[11].type,
      caption: georgeMediaArray[11].captions[1],
      subcaption: georgeMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: georgeMediaArray[12]._id,
      mediaItemURL: georgeMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[12].type,
      caption: georgeMediaArray[12].captions[2],
      subcaption: georgeMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: georgeMediaArray[10]._id,
      mediaItemURL: georgeMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[10].type,
      caption: georgeMediaArray[10].captions[2],
      subcaption: georgeMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[13]._id,
      mediaItemURL: georgeMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[13].type,
      caption: georgeMediaArray[13].captions[0],
      subcaption: georgeMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[17]._id,
      mediaItemURL: georgeMediaArray[17].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[17].type,
      caption: georgeMediaArray[17].captions[1],
      subcaption: georgeMediaArray[17].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow this is about as good as you're capable of looking. Good job`,
      verdict: 'Yes',
    },
    {
      feedback: `No... just no`,
      verdict: 'No',
    },
    {
      feedback: `Just when I thought it couldn't get any worse`,
      verdict: 'No',
    },
    {
      feedback: `A little bit funny as a change of pace photo`,
      verdict: 'Somewhat',
    },
    {
      feedback: `The worst one yet`,
      verdict: 'No',
    },
    {
      feedback: `OK, this one is actually good`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: georgeBio._id,
    vitalInfo: { ...georgeBio.vitalInfo },
    prompts: [
      { ...georgeBio.prompts[0] },
      { ...georgeBio.prompts[1] },
      { ...georgeBio.prompts[2] }
    ],
    aboutMe: georgeBio.aboutMe[0],
    hobbies: [georgeBio.hobbies[0], georgeBio.hobbies[1], georgeBio.hobbies[2], georgeBio.hobbies[3], georgeBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `What happens when they find out you're not actually an architect?`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: 'Umm... way too... real',
      verdict: 'No', 
    },
    promptsFeedback: [
      {
        feedback: `If this is a joke nobody will get it`,
        verdict: 'No', 
      },
      {
        feedback: `This is grotesque`,
        verdict: 'No', 
      },
      {
        feedback: `Kind of funny, sure`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `George is a total slob`,
    good: `The first photo and the friend pic were good. All of the others weren't`,
    notGood: `The scowls, the sloppiness, and the disregard for general decency`,
    verdict: `George is nowhere close to presenting an attractive self, though, now that I think about it, this may be *his* most attractive self`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...jerryReviewerReviewBumble },
  reviewerProfile: { ...jerryReviewerProfile },
  bioItems: { ...georgeBio },
  mediaItems: [ ...georgeMediaArray ],
}

export const kramerProfileReviewTinder = {
  _id: 'kramerProfileReviewTinderId',
  userId: 'georgeUserId',
  userEmail: 'george@email.com',
  datingProfileId: 'georgeDatingProfileTinderId',
  reviewerProfileId: 'kramerReviewerProfileId',
  reviewerEmail: 'kramer@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: georgeMediaArray[16]._id,
      mediaItemURL: georgeMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[16].type,
      caption: georgeMediaArray[16].captions[0],
      subcaption: georgeMediaArray[16].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[11]._id,
      mediaItemURL: georgeMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[11].type,
      caption: georgeMediaArray[11].captions[1],
      subcaption: georgeMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: georgeMediaArray[12]._id,
      mediaItemURL: georgeMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[12].type,
      caption: georgeMediaArray[12].captions[2],
      subcaption: georgeMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: georgeMediaArray[10]._id,
      mediaItemURL: georgeMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[10].type,
      caption: georgeMediaArray[10].captions[2],
      subcaption: georgeMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[13]._id,
      mediaItemURL: georgeMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[13].type,
      caption: georgeMediaArray[13].captions[0],
      subcaption: georgeMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[17]._id,
      mediaItemURL: georgeMediaArray[17].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[17].type,
      caption: georgeMediaArray[17].captions[1],
      subcaption: georgeMediaArray[17].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow this is about as good as you're capable of looking. Good job`,
      verdict: 'Yes',
    },
    {
      feedback: `No... just no`,
      verdict: 'No',
    },
    {
      feedback: `Just when I thought it couldn't get any worse`,
      verdict: 'No',
    },
    {
      feedback: `A little bit funny as a change of pace photo`,
      verdict: 'Somewhat',
    },
    {
      feedback: `The worst one yet`,
      verdict: 'No',
    },
    {
      feedback: `OK, this one is actually good`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: georgeBio._id,
    vitalInfo: { ...georgeBio.vitalInfo },
    prompts: [
      { ...georgeBio.prompts[0] },
      { ...georgeBio.prompts[1] },
      { ...georgeBio.prompts[2] }
    ],
    aboutMe: georgeBio.aboutMe[0],
    hobbies: [georgeBio.hobbies[0], georgeBio.hobbies[1], georgeBio.hobbies[2], georgeBio.hobbies[3], georgeBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `What happens when they find out you're not actually an architect?`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: 'Umm... way too... real',
      verdict: 'No', 
    },
    promptsFeedback: [
      {
        feedback: `If this is a joke nobody will get it`,
        verdict: 'No', 
      },
      {
        feedback: `This is grotesque`,
        verdict: 'No', 
      },
      {
        feedback: `Kind of funny, sure`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `George is a total slob`,
    good: `The first photo and the friend pic were good. All of the others weren't`,
    notGood: `The scowls, the sloppiness, and the disregard for general decency`,
    verdict: `George is nowhere close to presenting an attractive self, though, now that I think about it, this may be *his* most attractive self`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...kramerReviewerReviewTinder },
  reviewerProfile: { ...kramerReviewerProfile },
  bioItems: { ...georgeBio },
  mediaItems: [ ...georgeMediaArray ],
}